<div [class]="data?.className + ' notification-snackbar-div flex flex-row'">
  <p [innerHTML]="data.message" class="flex-1"></p>
  <footer>
    <span *ngIf="data.count > 1">Message {{data.index + 1}} of {{data.count}}</span>
    <button class="close-button" mat-flat-button color="primary" (click)="snackBarRef.dismissWithAction()">Close</button>
  </footer>
</div>
